import type { LabeledCode } from './labeledCode';

/** Capitalizes only the first letter, lowercases the rest. For text from Homère Classic (stored in ALL CAPS). */
export const capitalizeFirst = (v: string | undefined): string | undefined =>
  v ? v.charAt(0).toUpperCase() + v.slice(1).toLowerCase() : v;

/** Applies capitalizeFirst() to the libelle of a LabeledCode, leaving code untouched. */
export const capitalizeLabel = (lc: LabeledCode | undefined): LabeledCode | undefined =>
  lc?.libelle ? { ...lc, libelle: capitalizeFirst(lc.libelle) ?? lc.libelle } : lc;

/** Applies capitalizeLabel() to each entry of a LabeledCode list, dropping undefined results. */
export const capitalizeLabels = (arr: LabeledCode[] | undefined): LabeledCode[] =>
  (arr ?? []).map(lc => capitalizeLabel(lc) ?? lc);
